export const currencyFormat = (locale, number) => {
    return new Intl.NumberFormat(locale).format(number)
};